export default "__VITE_ASSET__B7v9CBQ4__"